import React from 'react';
import styled from 'styled-components';

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.75rem;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

const TableHeader = styled.thead`
  background: rgba(255, 255, 255, 0.08);
`;

const TableHeaderRow = styled.tr``;

const TableHeaderCell = styled.th`
  padding: 1rem;
  text-align: ${props => props.align || 'left'};
  font-size: 0.875rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  vertical-align: middle;
`;

const TableBody = styled.tbody``;

const TableRow = styled.tr`
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: background 0.2s;
  border: ${props => props.isHighlighted ? '2px solid #5ce9ff' : 'none'};
  border-left: ${props => props.isHighlighted ? '4px solid #5ce9ff' : 'none'};
  
  &:hover {
    background: rgba(255, 255, 255, 0.03);
  }
  
  &:last-child {
    border-bottom: ${props => props.isHighlighted ? '2px solid #5ce9ff' : '1px solid rgba(255, 255, 255, 0.05)'};
  }
`;

const TableCell = styled.td`
  padding: 1rem;
  color: white;
  font-size: 0.875rem;
  vertical-align: middle;
  text-align: ${props => props.align || 'left'};
`;

const EmptyMessage = styled.div`
  padding: 2rem;
  text-align: center;
  color: #9ca3af;
  font-size: 0.875rem;
`;

const DataTable = ({ 
  columns = [], 
  data = [], 
  emptyMessage = 'No data available',
  onRowClick,
  keyExtractor = (item, index) => item.id || item._id || index,
  rowHighlight = null // Function that returns true if row should be highlighted
}) => {
  if (!data || data.length === 0) {
    return <EmptyMessage>{emptyMessage}</EmptyMessage>;
  }

  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <TableHeaderRow>
            {columns.map((column, index) => (
              <TableHeaderCell 
                key={column.key || index}
                align={column.align}
                style={column.headerStyle}
              >
                {column.label}
              </TableHeaderCell>
            ))}
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow 
              key={keyExtractor(row, rowIndex)}
              onClick={() => onRowClick && onRowClick(row, rowIndex)}
              style={{ cursor: onRowClick ? 'pointer' : 'default' }}
              isHighlighted={rowHighlight ? rowHighlight(row, rowIndex) : false}
            >
              {columns.map((column, colIndex) => (
                <TableCell 
                  key={column.key || colIndex}
                  align={column.align}
                  style={column.cellStyle}
                >
                  {column.render 
                    ? column.render(row[column.key], row, rowIndex)
                    : row[column.key] || '-'
                  }
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DataTable;

